import {
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';

import {
  IonicModule,
  IonicRouteStrategy,
} from '@ionic/angular';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
import { throwIfAlreadyLoaded } from '@ups/xplat/utils';
import { UpsCoreModule } from '@ups/xplat/web/core';

@NgModule({
  imports: [UpsCoreModule, IonicModule.forRoot()],
  providers: [
    // StatusBar,
    // SplashScreen,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
  ],
})
export class UpsIonicCoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: UpsIonicCoreModule
  ) {
    throwIfAlreadyLoaded(
      parentModule,
      'UpsIonicCoreModule'
    );
  }
}
